query GetEvent($id: ID!) {
  event(id: $id) {
    id
    strapiSlug
    status
    eventType
    registrationMode
    registrationHostedInApp
    hostedRegistrationUrl
    title
    startsAt
    endsAt
    timezone
    createdAt
    locationName
    locationAddress
    locationCity
    locationMapUrl
    calendarDescription
    capacity
    waitlistEnabled
    waitlistAutoPromote
    offerExpiryHours
    changesLockAt
    waitlistClosesAt
    maxPromotionSkips
    plusOnesEnabled
    maxPlusOnes
    collectPlusOneDetails
    formConfig
    interestQuestions
    termsUrl
    termsVersion
    slackChannel
    contactPhone
    manager {
      id
      name
    }
    emailOverrides
    googleCalendarEventId
    googleCalendarUrl
    calendarResponsesCheckedAt
    checkInClosedAt
    weekReminderMode
    dayReminderMode
    reminders {
      kind
      mode
      sendsAt
      autoSentAt
      recipientCount
      queuedCount
      unavailableReason
    }
    followUps {
      segment
      recipientCount
      queuedCount
      unavailableReason
    }
    campaign {
      id
      name
      salesforceId
    }
    capacityHeldCount
    remainingCapacity
    overCapacity
    confirmedCount
    offeredCount
    cancelledCount
    waitlistedPeopleCount
    waitlistedPartiesCount
    interestedCount
    attendees {
      id
      uuid
      firstName
      lastName
      email
      status
      jobTitle
      company
      dietaryRequirements
      dietaryRequirementsOther
      accessibilityRequirements
      sourceOfInvitation
      sourceOfInvitationOther
      customAnswers
      consentToIncludeInGuestlist
      plusOne
      parentAttendeeId
      cancelledAt
      cancellationReason
      cancelledFromStatus
      offerExpiresAt
      calendarResponse
      earlyAccessAt
      syncStatus
      createdAt
      spoc
      focusMember
      preferredName
      pledgeDate
      eventsAttended
      avatarUrl
      contactSalesforceId
      heldUpdateCount
      contactDifferences {
        field
        guestValue
        salesforceValue
        salesforceUpdatable
      }
    }
    waitlist {
      id
      uuid
      waitlistPosition
      promotionSkipCount
      partySize
      createdAt
      eventAttendees {
        id
        uuid
        firstName
        lastName
        status
        plusOne
        offerExpiresAt
        avatarUrl
        contactSalesforceId
        contactDifferences {
          field
          guestValue
          salesforceValue
          salesforceUpdatable
        }
      }
    }
    registrationsPerDay {
      date
      count
    }
    outboxHealth {
      pendingCount
      failedCount
      failedEntries {
        id
        kind
        transitionKey
        status
        attempts
        lastError
        createdAt
      }
    }
  }
}
